export default __webpack_public_path__ + "static/media/LOGOdark.c183b525.png";